import React from 'react';
import { Link } from 'react-router-dom';

const NotFound: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center p-8 max-w-md">
        <div className="mb-6">
          <span className="text-6xl font-bold text-blue-500">404</span>
        </div>
        <h1 className="text-3xl font-bold mb-3">Page Not Found</h1>
        <p className="text-gray-600 mb-8">
          Oops! The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="space-y-4">
          <p className="text-gray-700">
            You might want to check out:
          </p>
          <div className="flex flex-col space-y-3">
            <Link
              to="/"
              className="px-6 py-3 bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
            >
              Go to Dashboard
            </Link>
            <Link
              to="/categories"
              className="px-6 py-3 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300 transition-colors"
            >
              Browse Quizzes
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;